var map = {
	"./bundler/contract": 24248,
	"./dfinity/contract": 47883,
	"./ethereum/contract": 33088,
	"./intmax/contract": 73706,
	"./nostr/contract": 26286,
	"./poseidon/contract": 59213,
	"./weavedb-bpt/contract": 38810,
	"./weavedb-kv/contract": 75693,
	"./weavedb/contract": 95134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40831;